<div
  class="coverages-outer-container"
  [formGroup]="form"
  id="policySummaryCard-{{ product.type }}"
  >
  @if (showPremium) {
    <div class="premium-section bolt-justify-content-center">
      <h2
        class="premium-monthly"
        attr.id="powersportsPremiumMonthly-{{ product.type }}"
        >
        {{
        priceSummaryDisplayProduct.installmentPrice
        }}<span class="per-month"><strong>{{
        priceSummaryDisplayProduct.installmentFrequency
      }}</strong></span>
    </h2>
  </div>
  <div class="bolt-row bolt-justify-content-center">
    <h3
      class="premium-total"
      attr.id="powersportsPremiumTotal-{{ product.type }}"
      >
      {{ priceSummaryDisplayProduct.totalPrice }}
    </h3>
    <span class="per-month-monthly">
      {{ priceSummaryDisplayProduct.termLength }}
    </span>
  </div>
  <hr />
}

<div class="bolt-row effective-container">
  <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
    @if (!showDatePicker) {
      <div
        class="update-effectiveDate-container"
        (click)="showDatePicker = true"
        >
        <a id="mcsc-Effective-date-{{ product.type }}"
          >Effective date {{ form.value.effectiveDate }}</a
          >
          <bolt-icon
            name="pencil"
            [attr.id]="'mcsc-pencil-' + product.type"
            color="mediumBlue"
            [attr.size]="maxSizeMini ? 'sm' : 'md'"
            class="icon-top-padding mt-05"
          ></bolt-icon>
        </div>
      }
      @if (showDatePicker) {
        <nwx-datepicker-input
          controlId="effectiveDate"
          id="mcsc-effective-date-{{ product.type }}"
          label="Effective date"
          controlName="effectiveDate"
          placeholder="MM/DD/YYYY"
          [minDate]="policyDateOptions?.minDate || null"
          [maxDate]="policyDateOptions?.maxDate || null"
          [disabled]="(updateInProgress$ | async) || false"
          [relevantProduct]="product.type"
          [quoteCreateDate]="product.quoteCreateDate"
          [bumpHeaderMargin]="true"
        ></nwx-datepicker-input>
      }
    </div>
    <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
      <div
        class="remove-policy-container"
        (click)="promptToRemovePolicy($event)"
        id="mcdc-remove-policy-{{ product.type }}"
        >
        <a href="#" id="mcdc-Remove-policy-{{ product.type }}">Save submission for later</a>
        <bolt-icon
          name="folder"
          [attr.id]="'mcdc-folder-' + product.type"
          color="mediumBlue"
          [attr.size]="maxSizeMini ? 'sm' : 'md'"
          class="icon-top-padding"
        ></bolt-icon>
      </div>
      <div
        class="remove-policy-container"
        (click)="promptToWithdrawPolicy($event)"
        id="mcdc-withdraw-policy-{{ product.type }}"
        >
        <a href="#" id="mcdc-Withdraw-policy-{{ product.type }}">Delete submission</a>
        <bolt-icon
          name="trash"
          [attr.id]="'mcdc-trash-' + product.type"
          color="mediumBlue"
          [attr.size]="maxSizeMini ? 'sm' : 'md'"
          class="icon-top-padding"
        ></bolt-icon>
      </div>
    </div>
  </div>
  <hr />

  @if (showPremium) {
    @for (vehicle of vehicles; track vehicle.vehicleId) {
      <div
        class="details-container"
        id="vehicleCoverageDetails-{{ vehicle.vehicleId }}"
        >
        <div class="info-row heading">
          <div class="bolt-row bolt-justify-content-between">
            <div class="bolt-col-xs-xs-6">
              <strong
                >{{ vehicle.year }} {{ vehicle.make || '' | titlecase }}
                {{ vehicle.model || '' | titlecase }}
              </strong>
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="bolt-row bolt-justify-content-between">
            <div class="bolt-col-xs-6 no-left-pad">
              Comprehensive deductible
            </div>
            <div class="bolt-col-xs-6" id="compDisplay-{{ vehicle.vehicleId }}">
              {{ getDeductibleById(vehicle.vehicleId, 'COMP') }}
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="bolt-row bolt-justify-content-between">
            <div class="bolt-col-xs-6 no-left-pad">Collision deductible</div>
            <div class="bolt-col-xs-6" id="collDisplay-{{ vehicle.vehicleId }}">
              {{ getDeductibleById(vehicle.vehicleId, 'COLL') }}
            </div>
          </div>
        </div>
        <ng-container>
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">
                Physical Damage Settlement Option
              </div>
              <div
                class="bolt-col-xs-6"
                id="pdsoDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'PDSO') }}
              </div>
            </div>
          </div>
        </ng-container>
        @if (
          vehicle.productType === 'RV' &&
          vehicle.vehicleType !== 'UtilityTrailer'
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Full timers package</div>
              <div
                class="bolt-col-xs-6"
                id="ftpkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getDeductibleById(vehicle.vehicleId, 'FTPKG') }}
              </div>
            </div>
          </div>
        }
        @if (
          vehicle.productType === 'RV' &&
          vehicle.vehicleType !== 'UtilityTrailer'
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">
                Pleasure use vacation liability
              </div>
              <div
                class="bolt-col-xs-6"
                id="vacliabDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getDeductibleById(vehicle.vehicleId, 'VACLIAB') }}
              </div>
            </div>
          </div>
        }
        @if (
          vehicle.productType === 'Boat' && vehicle.vehicleType === 'boat'
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Package</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'PKG') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('CEC', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Custom Equipment</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'CEC') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('RSA', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Roadside Assistance</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'RSA') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('OEM', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Original Equipment Manufacturer</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'OEM') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('RENTRE', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Rental Reimbursement</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'RENTRE') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('TL', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">{{ product.type === 'Boat' ? 'On-Water Towing' : 'Towing and Labor' }}</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'TL') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('PEREF', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Personal Effects</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'PEREF') }}
              </div>
            </div>
          </div>
        }
        @if (
          getAvailableById('SGLASS', vehicle.vehicleId)
          ) {
          <div class="info-row">
            <div class="bolt-row bolt-justify-content-between">
              <div class="bolt-col-xs-6 no-left-pad">Safety Glass</div>
              <div
                class="bolt-col-xs-6"
                id="pkgDisplay-{{ vehicle.vehicleId }}"
                >
                {{ getCovDescription(vehicle.vehicleId, 'SGLASS') }}
              </div>
            </div>
          </div>
        }
      </div>
    }
    <hr />
    <details class="details-container" id="limitsOverview-{{ product.type }}">
      <summary><strong>Limits overview</strong></summary>
      @for (limit of overviewLimits; track limit.value) {
        <div
          class="bolt-row bolt-justify-content-between limits-overview"
          >
          <div class="bolt-col-xs-xs-6 info-row indent">{{ limit.description }}</div>
          <div class="bolt-col-xs-xs-6 info-row">
            {{ limit.value }}
          </div>
        </div>
      }
    </details>
  } @else {
    <div class="coverages-footer pb-20" id="pcdc-premiumSubstitute">
      <nwx-notification-bubble type="info">
        <p style="font-size: large; font-weight: 500;">Review your rating tasks</p>
        <p>The rate isn’t available, because there may be unfinished tasks or errors. If you see any errors, request UW approval.</p>
        <div class="d-flex flex-column bolt-justify-content-between">
          <bolt-button color="mediumBlue"
            type="outline"
            class="button-float"
            size="md"
            (click)="scrollToTasks()"
            >Review rating tasks</bolt-button
            >
          </div>
        </nwx-notification-bubble>
      </div>
      <hr />
      <div class="details-container-last"></div>
    }
    <div class="button-container">
      <div class="bolt-row">
        <div class="bolt-col-xs">
          <bolt-button
            type="solid"
            size="sm"
            [attr.id]="'acdc-view-edit-coverage'"
            (click)="editCoverages()"
            >View/edit all coverages</bolt-button
            >
          </div>
        </div>
      </div>
    </div>

